import { MaceClaim } from '@/core-types/claim';
import { RootState } from '../root-reducer';
import { MacePlan } from '@/core-types/plan';
import { UpdateCustomerInfoDto } from '@/core-types/file-mace-claim';
import { formatPhoneNumber } from '../user/helpers';

export const getMaceClaims = (state: RootState): MaceClaim[] => state.user.claims as MaceClaim[];
export const getActiveMaceClaim = (state: RootState): Partial<MaceClaim> => state.fileMaceClaim.activeMaceClaim;

export const mapApiInsertedMaceClaim = (payload: unknown): Partial<MaceClaim> => {
  return {
    id: payload['claim_id'],
  };
};

export const isCustomerInfoModify = (current: MacePlan, modified: UpdateCustomerInfoDto) => {
  const mappedModified = {
    customerFirstName: modified?.firstName || '',
    customerLastName: modified?.lastName || '',
    customerAddressLine1: modified?.address?.[0]?.addressLine1 || '',
    customerAddressLine2: modified?.address?.[0]?.addressLine2 || '',
    customerCity: modified?.address?.[0]?.city || '',
    customerState: modified?.address?.[0]?.state || '',
    customerCountry: modified?.address?.[0]?.country || '',
    customerZip: modified?.address?.[0]?.zip || '',
    customerPhoneNumber: formatPhoneNumber(modified?.address?.[0]?.customerPhone?.[0]?.number || '') || '',
    // customerPhoneType: modified.address?.[0]?.customerPhone?.[0]?.phoneType || '',
    // customerPhoneExt: modified.address?.[0]?.customerPhone?.[0]?.phoneExt || '',
    customerEmail: modified.address?.[0]?.email || '',
    customerAddressCode: modified.address?.[0]?.addressCode || '',
  };

  const keysToMatch = [
    'customerFirstName',
    'customerLastName',
    'customerAddressLine1',
    'customerAddressLine2',
    'customerCity',
    'customerState',
    'customerCountry',
    'customerZip',
    'customerPhoneNumber',
    // 'customerPhoneType',
    // 'customerPhoneExt',
    'customerEmail',
    'customerAddressCode',
  ];

  return keysToMatch.some((key) => current[key] !== mappedModified[key]);
};
